import React from 'react';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import {
    xAxisTunables,
    yAxisTunables,
    gridTunables,
    legendTunables,
    metaInfoTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import ActionCheckboxGroup from 'components/_UI/Forms/Actions/ActionCheckboxGroup';

export const HyperSpaceBubblePlotChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Bubble Plot Chart'),
            startOpen: true,
        } as CollapseProps,
        children: [
            ...headerTunables(widget),
            opacityTunables(widget),
            <ActionCheckboxGroup
                key='widget.options.zeroFill'
                label={i18n.t('Zero Fill')}
                option={widget.options}
                value='zeroFill'
            />,
            gridTunables(widget),
        ],
    },
    metaInfoTunables({ widget, color: true, image: true }),
    xAxisTunables({ widget, mergedTheme }),
    yAxisTunables({ widget, mergedTheme, axisIsDim: false }),
    legendTunables(widget, { metric: false }),
];
